import { useOutletContext } from 'react-router-dom'
import { TabelaHorarioFuncionario } from 'service/api'

export function useTrocaTabelaHorarioContext() {
    return useOutletContext<{
        data?: TabelaHorarioFuncionario[]
    }>()
}
